import EffectParameterSlider from "components/effects/EffectParameterSlider.js"
import Dropdown from 'react-dropdown';
import Documented from 'components/help/Documented.js';
import React, { useEffect, useCallback, useState} from 'react';
import ParametersMapper from './ParametersMapper.js';
import {connect} from 'react-redux';
import CheckboxParameter from './CheckboxParameter.js';
import {EQ, LTE, GTE}from "constants/conditional-types.js";

const MODE_OPTIONS = [
    {label: "==", value: EQ},
    {label: "<=", value: LTE},
    {label: ">=", value: GTE},
];


const ConditionalParametersComponent = ({mode, sequencerEngine, effect, isDraggable}) => { 
    let [parameters, setParameters] = useState(effect._parameters);
    let max = 1;
    let min = 0;
    for (let parameter of parameters.slice(1)) {
        if (!parameter) {
            continue;
        }
        if (parameter.min < min) {
            min = parameter.min;
        }
        if (parameter.max > max) {
            max = parameter.max;
        }
    }
    let parameter = effect._parameters[0];
    return (

        <div className="control-parameters accumulator">
          <div className="acc-column">
          <Documented element={effect.modeParameter} className="synced-parameter">
            <span>Condition: </span>
            <Dropdown
              placeholder="C"
              options={MODE_OPTIONS}
              value={MODE_OPTIONS.find(x => x.value === mode)}
              onChange={(o) => effect.conditionalTypeParameter.set(o.value)}
            />
          <EffectParameterSlider
            name={'Cond. Value'}
            parameter={effect.conditionalValueParameter}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            step={0.001}
            min={parameter ? parameter.min : 0}
            max={parameter ? parameter.max : 1}/>
          <EffectParameterSlider
            name={'Then. Value'}
            parameter={effect.thenValueParameter}
            isParameter={true}
            sequencerEngine={sequencerEngine}
            lfoEnabled={true}
            step={0.001}
            min={min}
            max={max}/>
          </Documented>
          </div>
          <ParametersMapper isDraggable={isDraggable} effect={effect}>
            <EffectParameterSlider
              name={'Ramp Time'}
              parameter={effect.rampTimeParameter}
              isParameter={true}
              sequencerEngine={sequencerEngine}
              lfoEnabled={true}
              unit="ms"
              step={1}
              min={1}
              max={3000}/>
            <CheckboxParameter name="Reset on step 1" parameter={effect.resetAtZeroParameter}/>
          </ParametersMapper>
        </div>
    );
};

const ListItem = ({effect, item, i, key, isCurrent}) => {
    let [value, setValue] = useState(item === undefined ? "" : undefined);

    useEffect(() => {
        if (item === undefined) {
            setValue("");
        } else {
            setValue(undefined);
        }
    }, [item, setValue]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            let _value = parseFloat(value);
            if (isNaN(_value)) {
                return;
            }
            let _list = effect.valueList;
            if (i === undefined) {
                // add the item
                effect.valueList = [... _list, _value];
            }  else {
                // set the item
                _list[i] = _value;
                effect.valueList = _list;
            }
            setValue(undefined);
        }
    }, [setValue, value, effect, i]);

    const onDelete = useCallback((e) => {
        e.stopPropagation();
        let valueList = [... effect.valueList];
        valueList.splice(i, i);
        effect.valueList = valueList;
    }, [effect, i]);

    if (value !== undefined) {
        return (
            <div className="value-list-item">
              <input
                placeholder="Enter value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={onKeyDown}
              />
            </div>
        );
    } else {
        return (
            <div
              onClick={() => setValue(item)}
              className={isCurrent ? "value-list-item current" : "value-list-item"}>
              <div>{item}</div>
              <div onClick={onDelete} className="delete-btn">x</div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        mode: props.effect.conditionalType,
        parameter: props.effect._parameters[0]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionalParametersComponent);
